import type { SxProps, Theme } from '@mui/material/styles';

export const dataGridDensityTransitionSx = {
  '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
    height: 'var(--density-row-height, var(--height)) !important',
    minHeight: 'var(--density-row-height, var(--height)) !important',
    maxHeight: 'var(--density-row-height, var(--height)) !important',
    '--height': 'var(--density-row-height, var(--height)) !important',
    transition: 'none',
  },
  '& .MuiDataGrid-cell': {
    lineHeight: 'calc(var(--density-row-height, var(--height)) - 1px)',
  },
  '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': {
    height:
      'var(--density-header-height, var(--DataGrid-headerHeight)) !important',
    minHeight:
      'var(--density-header-height, var(--DataGrid-headerHeight)) !important',
    maxHeight:
      'var(--density-header-height, var(--DataGrid-headerHeight)) !important',
    transition: 'none',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    transition: 'none',
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    transition: 'none',
  },
  '@media (prefers-reduced-motion: reduce)': {
    '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
      transition: 'none',
    },
    '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': {
      transition: 'none',
    },
    '& .MuiDataGrid-virtualScrollerRenderZone': {
      transition: 'none',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      transition: 'none',
    },
  },
} satisfies SxProps<Theme>;
